import React from 'react';
import CourierRoutePage from './CourierRoutePage';
import { ROUTE_PAGES } from '../data/routePages';

const CourierToAustraliaPage = () => <CourierRoutePage page={ROUTE_PAGES.australia} />;

export default CourierToAustraliaPage;
